import type { FAQPage, Question, WithContext } from 'schema-dts';

import { JsonLd } from './JsonLd';

export interface QuestionAnswer {
    question: string;
    answer: string;
}

export function FaqSeo({
    id,
    qaArray,
}: Readonly<{
    id: string;
    qaArray: QuestionAnswer[];
}>) {
    const mainEntity = qaArray
        .filter(({ question, answer }) => question && answer)
        .map(
            ({ question, answer }): Question => ({
                '@type': 'Question',
                name: question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: answer,
                },
            })
        );

    const faqSchema: WithContext<FAQPage> = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity,
    };

    if (mainEntity.length === 0) {
        return null;
    }

    return (
        <section>
            <JsonLd id={id} data-testid={id} json={faqSchema} />
        </section>
    );
}
